import type { CarePlusPlanTier, CarePlusPlanDuration } from "./types";

export const TIER_DEFAULT_PERIOD: Record<string, number> = { basic: 1, pro: 3, max: 6 };
export const DEFAULT_PERIOD_MONTHS = 3;

export const defaultDurationFor = (tier: CarePlusPlanTier | null): CarePlusPlanDuration | null => {
  if (!tier?.durations?.length) return null;
  const preferred = TIER_DEFAULT_PERIOD[tier.tier] ?? DEFAULT_PERIOD_MONTHS;
  return tier.durations.find((d) => d.period_months === preferred) ?? tier.durations[0];
};
